import { path } from 'd3-path'
import Symbol2d from '../2d.js'

export default class Octagon extends Symbol2d {

  handles = [{
    defaults: [.115, 0],
    constraints: (dimensions) => {
      let max = Math.min(dimensions.width / 2, dimensions.height / 2) / dimensions.width
      return [
        [0.05, max], null
      ]
    },
    cursor: 'ew-resize'
  }]

  path (dimensions, handles) {
    const _path = path()
    const offset = dimensions.width * handles[0][0]

    _path.moveTo(offset, 0)
    _path.lineTo(dimensions.width - offset, 0)
    _path.lineTo(dimensions.width, offset)
    _path.lineTo(dimensions.width, dimensions.height - offset)
    _path.lineTo(dimensions.width - offset, dimensions.height)
    _path.lineTo(offset, dimensions.height)
    _path.lineTo(0, dimensions.height - offset)
    _path.lineTo(0, offset)
    _path.closePath()

    return _path.toString()
  }

  textContainer(dimensions, handles) {
    const offset = dimensions.width * handles[0][0]
    const pt1 = [0, offset]
    const pt2 = [offset, 0]
    const midpoint = [(pt1[0] + pt2[0]) / 2, (pt1[1] + pt2[1]) / 2]

    const width = (dimensions.center[0] - midpoint[0]) * 2
    const height = dimensions.height - (midpoint[1] * 2)

    return {
      center: dimensions.center,
      width,
      height,
    }
  }

}
